import { Component } from '@angular/core';

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {first} from "rxjs/operators";
import {ReservationData} from "../models/reservationData";
import {addHours} from "date-fns";
import {ReservationDataService} from "../services/reservationData.service";

@Component({
    templateUrl: './trainerDashboard.component.html',
    styleUrls: ['./trainerDashboard.component.scss', ]
})
export class TrainerDashboardComponent {
    title = 'app-dashboard';
    reservations: ReservationData[] = [];

    constructor(
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private reservationDataService: ReservationDataService,
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Trainer dashboard');

        this.loadEvents();
    }

    loadEvents() {
        let today = new Date();
        let month = new Date(today.setDate(today.getDate()+31));

        this.reservationDataService.getByDate(this.convertDateToString(new Date()) + ' 00:00:00', this.convertDateToString(month) + ' 23:59:59')
            .pipe(first())
            .subscribe((reservations: ReservationData[]) => {
                    this.reservations = reservations;
                },
                error => {

                });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    }
}
